/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function ChartUp({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 13 9" {...props}><path fill="currentColor" d="M12.424.176a.599.599 0 0 1 .176.417V4.6a.6.6 0 1 1-1.2 0V2.049L7.424 6.024a.6.6 0 0 1-.848 0L5 4.45 1.424 8.024a.6.6 0 1 1-.848-.848l4-4a.6.6 0 0 1 .848 0L7 4.75 10.55 1.2H8A.6.6 0 0 1 8 0h4a.598.598 0 0 1 .424.176Z" /></svg>;
}
;